<template>
  <div :class="{ 'action-menu': true, 'action-menu--active': is_active }">
    <menu-item
      v-if="is_allow_config"
      type="config"
      class="action-menu__item"
      @click.native.stop="$emit('button-config')"
    />
    <menu-item
      v-if="is_allow_create_connection"
      type="connection"
      class="action-menu__item"
      @click.native.stop="$emit('button-connection')"
    />
    <menu-item v-if="is_allow_delete" type="trash" class="action-menu__item" @click.native.stop="$emit('button-remove')" />
  </div>
</template>

<script>
  import MenuItem from './_menu-item';

  export default {
    components: {
      MenuItem
    },
    props: {
      is_active: {
        type: Boolean,
        default: false
      },

      is_allow_config: {
        type: Boolean,
        default: false
      },

      is_allow_delete: {
        type: Boolean,
        default: false
      },

      is_allow_create_connection: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style lang="scss">
  .action-menu {
    width: 12px;

    &__item {
      top: 0;
      position: absolute;
      transform: translate(0px, 100%);
      transition: transform ease-in-out 0.3s;
    }

    &--active {
      .action-menu__item {
        &:nth-child(1) {
          transform: translate(0px, -30px);
        }

        &:nth-child(2) {
          transform: translate(28px, -22px);
        }

        &:nth-child(3) {
          transform: translate(50px, -1px);
        }

        &:nth-child(4) {
          transform: translate(57px, 29px);
        }

        &:nth-child(5) {
          transform: translate(50px, 59px);
        }

        &:nth-child(6) {
          transform: translate(28px, 81px);
        }
      }
    }
  }
</style>
